import { render, staticRenderFns } from "./delivery-method-selector-item.vue?vue&type=template&id=55710d80&"
import script from "./delivery-method-selector-item.vue?vue&type=script&lang=js&"
export * from "./delivery-method-selector-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports